import React from 'react'

export default function Footer () {
  return (
    <footer className='bt b--light-gray f6 gray pa5'>
      <div className='measure-wide tc center ph2'>
        Made with &lt;3 by Nate Taylor
      </div>
    </footer>
  )
}




// WEBPACK FOOTER //
// ./src/layouts/footer.js